import { render } from "./DashboardSupport.vue?vue&type=template&id=0b9de1ea"
import script from "./DashboardSupport.vue?vue&type=script&lang=js"
export * from "./DashboardSupport.vue?vue&type=script&lang=js"

import "./DashboardSupport.vue?vue&type=style&index=0&id=0b9de1ea&lang=scss"

import exportComponent from "/var/www/vimashenets/data/www/valera.report.tz365.ru/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__